var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQueueOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 225,
    viewBox: "0 0 281 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15_62)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.908 32.0834L152 57.0939C150.194 59.4917 147.854 61.4359 145.168 62.7757C142.482 64.1154 139.522 64.8136 136.52 64.8136C133.518 64.8136 130.556 64.1154 127.869 62.7757C125.183 61.4359 122.845 59.4917 121.039 57.0939L100.05 32.0834C93.6512 32.0834 87.5167 34.625 82.9924 39.1493C78.4681 43.6737 75.9246 49.8101 75.9246 56.2084V168.792C75.9246 175.19 78.4681 181.327 82.9924 185.851C87.5167 190.375 93.6512 192.917 100.05 192.917H172.425C178.823 192.917 184.959 190.375 189.484 185.851C194.008 181.327 196.55 175.19 196.55 168.792V56.2084C196.551 49.8928 194.077 43.8289 189.656 39.3182C185.236 34.8075 179.222 32.2097 172.908 32.0834ZM136.479 184.875C134.093 184.875 131.761 184.169 129.778 182.843C127.794 181.518 126.248 179.632 125.335 177.428C124.422 175.224 124.182 172.799 124.648 170.459C125.113 168.119 126.263 165.969 127.95 164.282C129.637 162.595 131.787 161.447 134.127 160.982C136.466 160.516 138.892 160.756 141.096 161.669C143.3 162.582 145.184 164.128 146.509 166.112C147.834 168.096 148.541 170.427 148.541 172.813C148.541 176.012 147.271 179.079 145.009 181.341C142.747 183.603 139.678 184.875 136.479 184.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.614 32.0834L146.531 50.9821C145.324 52.581 143.763 53.8763 141.97 54.7693C140.177 55.6624 138.201 56.1279 136.198 56.1279C134.195 56.1279 132.219 55.6624 130.426 54.7693C128.633 53.8763 127.072 52.581 125.865 50.9821L109.782 32.0834H162.614Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15_62",
    x: 60.9246,
    y: 24.0834,
    width: 150.625,
    height: 190.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.309804 0 0 0 0 0.454902 0 0 0 0 0.733333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15_62"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15_62",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQueueOnline);
export default __webpack_public_path__ + "static/media/icon_queue_online.c19d72f5e28a793967aa2ae98ea510d4.svg";
export { ForwardRef as ReactComponent };